// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3MP-S","errorLogs":"styles_errorLogs__bJkmC"};